import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import AddEntityForm from "../../templates/AddEntityForm";
import { useIntl } from "react-intl";
import { getItems } from "./EntityItems";

const EntityFormModal = (props) => {
  const { visible, hide, mode, record, entity } = props;
  const intl = useIntl();
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({});
  const createLoading = useSelector(
    (state) => state.pendingActions["tasks/create"]
  );

  const onFinish = async (values) => {
    hide();
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const onValuesChange = (values, form) => {
    setFormValues(values);
  };

  const items = getItems(entity, scopePrefix);
  const addText = intl.formatMessage({
    id:
      mode === "edit"
        ? `app.${entity}.edit_form_title`
        : `app.${entity}.new_form_title`,
  });

  return (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={hide}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      destroyOnClose={true}
    >
      <AddEntityForm
        formLayout={{
          labelCol: { span: 9 },
          wrapperCol: { span: 15 },
        }}
        resource="tasks"
        action="editor"
        activeEntity={record}
        items={items}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onEntityValuesChange={onValuesChange}
        onDecline={onDecline}
        saveLoading={createLoading}
        addText={addText}
        mode={mode}
        style={{
          padding: "0 24px 0px 24px",
          width: "900px",
        }}
        twoColumns={true}
      />
    </Modal>
  );
};

export default EntityFormModal;
